import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo, useState } from 'react';
import UILink from 'UIComponents/link/UILink';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import { MAX_AD_CAMPAIGNS_IN_CONSOLE_TABLE_CELL } from '../../../../constants/ads';
import { COMPONENT, EVENT, INTERACTION_TYPE } from '../../../../constants/tracking';
import { LoadingTableRow } from '../../../../utils/styles';
import usageTracker from '../../../../utils/usageTracker';
import DetailsPanel from '../../details-panel/DetailsPanel';
import AdCampaignName from './AdCampaignName';
export default function AdCampaignsCell({
  goalTarget
}) {
  const {
    goalType,
    assigneeType
  } = goalTarget;
  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  const adCampaignsForCell = useMemo(() => {
    if (!goalTarget.adCampaigns || !goalTarget.adCampaigns.length) return [];
    return goalTarget.adCampaigns.slice(0, MAX_AD_CAMPAIGNS_IN_CONSOLE_TABLE_CELL);
  }, [goalTarget.adCampaigns]);

  const handleViewAllCampaignsClicked = () => {
    usageTracker.track(EVENT.INTERACTION, {
      interactionType: INTERACTION_TYPE.VIEW_ALL_CAMPAIGNS_CLICK,
      screen: COMPONENT.GOALS_TABLE,
      goalType,
      assigneeType
    });
    setViewDetailsOpen(true);
  };

  const handleCloseDetailsPanel = () => {
    setViewDetailsOpen(false);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [adCampaignsForCell.length ? /*#__PURE__*/_jsxs(UIExpandableText, {
      maxHeight: 82,
      children: [adCampaignsForCell.map(adCampaign => {
        return /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(AdCampaignName, {
            campaign: adCampaign
          })
        }, adCampaign.adCampaignId);
      }), goalTarget.adCampaigns && goalTarget.adCampaigns.length > MAX_AD_CAMPAIGNS_IN_CONSOLE_TABLE_CELL && /*#__PURE__*/_jsx(UILink, {
        onClick: handleViewAllCampaignsClicked,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'goals-reporting-lib.table.viewAllCampaigns'
        })
      })]
    }) : /*#__PURE__*/_jsx(LoadingTableRow, {}), viewDetailsOpen && /*#__PURE__*/_jsx(DetailsPanel, {
      goalTarget: goalTarget,
      handleOnClose: handleCloseDetailsPanel
    })]
  });
}